import React, { Component } from "react";
import D from "../../../js/debounce.js";



class StarItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.scalePlaceholder  = this.scalePlaceholder.bind(this);


    // Cache label to see if it changes...
    this.cachedLabel = null;

    // Resize things after a debounce
    window.addEventListener("resize", D(() => {
      this.scalePlaceholder();
    }, 250));
  }



  // ===============================================================================================
  scalePlaceholder() {
    // console.log("SIDEBAR:\n scalePlaceholder()");

    // Implements scale() on a div to make it fit within a container (single line text)
    let wrEle = this.phWrapper;
    let scEle = this.phScaler;

    if (wrEle && scEle) {
      // console.log("SIDEBAR: starting");
      let wrWidth = wrEle.offsetWidth;
      let scWidth = scEle.offsetWidth;

      if (wrWidth && scWidth) {
        // console.log("SIDEBAR:\n ", scWidth, wrWidth);
        if (scWidth <= wrWidth) {
          // If the scaler is less than the container, use no scaling
          scEle.style.transform       = "";
          scEle.style.webkitTransform = "";
        }
        else {
          // If the scaler is greater than the container, use scaling!
          let scale = (wrWidth / scWidth);
          // console.log("SIDEBAR:\n ", scale);
          scEle.style.transform       = `scale(${scale})`;
          scEle.style.webkitTransform = `scale(${scale})`;
        }
      }
    }
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Trigger a rescale if the label changes
    if (this.props.label !== this.cachedLabel) {
      this.cachedLabel = this.props.label;
      setTimeout(() => { this.scalePlaceholder(); }, 250);
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className="floating-sidebar__starlist__item"
        ref={(ele) => { this.phWrapper = ele; }}>

        <div className="floating-sidebar__starlist__item__label"
          ref={(ele) => { this.phScaler = ele; }}>

          {this.props.label}

        </div>

      </div>
    );
  }

}



export default StarItem
